import { NavRoute } from '@components/sidenav/routes';

export const creationNavRoutes: NavRoute[] = [
  {
    route: 'byproduct',
    label: 'Uusi sivutuote',
    icon: 'product',
    translationKey: 'NAV.CREATE_NEW_BYPRODUCT'
  },
  {
    route: 'slaughterhouse',
    label: 'Uusi raaka-ainetoimittaja',
    icon: 'partner',
    translationKey: 'NAV.CREATE_NEW_SLAUGHTERHOUSE'
  },
  {
    route: 'haulier',
    label: 'Uusi kuljetusyritys',
    icon: 'partner',
    translationKey: 'NAV.CREATE_NEW_HAULIER'
  },
  // {
  //   route: 'customer',
  //   label: 'Uusi loppputuoteasiakas',
  //   // TODO: Some other icon
  //   icon: 'customer',
  //   translationKey: 'NAV.CREATE_NEW_CUSTOMER'
  // },
  {
    route: 'service',
    label: 'Uusi palvelu',
    icon: 'service',
    translationKey: 'NAV.CREATE_NEW_SERVICE'
  }
];
